import React from 'react';
import {
  CheckboxWrapper,
  CheckboxContainer,
  CheckboxInput,
  CheckboxCustom,
  CheckboxLabel,
  CheckboxIcon,
} from './common-checkbox-style';

const CommonCheckbox = ({
  label,
  checked,
  onChange,
  name,
  id,
  disabled = false,
  ...props
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.checked, id);
    }
  };

  return (
    <CheckboxWrapper isDisabled={disabled}>
      <CheckboxContainer>
        <CheckboxInput
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          name={name}
          id={id}
          disabled={disabled}
          {...props}
        />
        <CheckboxCustom checked={checked} isDisabled={disabled}>
          {checked && <CheckboxIcon>✓</CheckboxIcon>}
        </CheckboxCustom>
      </CheckboxContainer>
      <CheckboxLabel htmlFor={id} isDisabled={disabled}>
        {label}
      </CheckboxLabel>
    </CheckboxWrapper>
  );
};

export default CommonCheckbox;
